'use client'

// ============================================================================
// Types
// ============================================================================

type FilterType = 'all' | 'running' | 'completed' | 'error' | 'review'

interface LogFiltersProps {
  currentFilter: FilterType
  onFilterChange: (filter: FilterType) => void
  counts: Record<FilterType, number>
  className?: string
}

// ============================================================================
// Component
// ============================================================================

export function LogFilters({
  currentFilter,
  onFilterChange,
  counts,
  className = ''
}: LogFiltersProps) {

  const filters: Array<{
    key: FilterType
    label: string
    icon: string
    color: string
    activeColor: string
  }> = [
    {
      key: 'all',
      label: 'Todos',
      icon: '📊',
      color: 'text-gray-700 dark:text-gray-300',
      activeColor: 'bg-gray-200 dark:bg-gray-700'
    },
    {
      key: 'running',
      label: 'Rodando',
      icon: '🔄',
      color: 'text-yellow-700 dark:text-yellow-400',
      activeColor: 'bg-yellow-100 dark:bg-yellow-900/30'
    },
    {
      key: 'completed',
      label: 'Concluídas',
      icon: '✅',
      color: 'text-green-700 dark:text-green-400',
      activeColor: 'bg-green-100 dark:bg-green-900/30'
    },
    {
      key: 'error',
      label: 'Erros',
      icon: '❌',
      color: 'text-red-700 dark:text-red-400',
      activeColor: 'bg-red-100 dark:bg-red-900/30'
    },
    {
      key: 'review',
      label: 'Review',
      icon: '📋',
      color: 'text-purple-700 dark:text-purple-400',
      activeColor: 'bg-purple-100 dark:bg-purple-900/30'
    }
  ]

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() => onFilterChange(filter.key)}
          className={`
            px-3 py-1.5 rounded-lg text-xs font-medium transition-all
            ${currentFilter === filter.key
              ? `${filter.activeColor} ${filter.color} ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-800`
              : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'
            }
          `}
        >
          <span className="mr-1">{filter.icon}</span>
          {filter.label}
          <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-xs ${
            currentFilter === filter.key
              ? 'bg-white/50 dark:bg-black/20'
              : 'bg-white/60 dark:bg-gray-800'
          }`}>
            {counts[filter.key]}
          </span>
        </button>
      ))}
    </div>
  )
}
